<template>
  <div class="group-manage">
    <div class="group-header">
      <span>分组</span>
      <div
        class="add-group"
        @click="showAddGroup"
      >
        <van-icon name="plus" />
        <span>新建分组</span>
      </div>
    </div>

    <div class="group-list">
      <van-cell-group>
        <van-cell
          v-for="group in groupList"
          :key="group.id"
          :title="group.name"
          is-link
          class="group-item"
        >
          <template #icon>
            <van-icon
              name="friends-o"
              class="group-icon"
            />
          </template>
          <template #right-icon>
            <!-- <van-icon
              name="delete-o"
              class="delete-icon"
              @click.stop="confirmDelete(group)"
            /> -->
          </template>
        </van-cell>
      </van-cell-group>
    </div>

    <!-- 新建分组弹窗 -->
    <van-popup
      v-model="showPopup"
      position="bottom"
      round
      class="add-group-popup"
    >
      <div class="popup-header">
        <span>新建分组</span>
        <van-icon
          name="cross"
          @click="showPopup = false"
        />
      </div>
      <div class="popup-content">
        <van-field
          v-model="newGroupName"
          label=""
          placeholder="请输入分组名称"
          maxlength="20"
          show-word-limit
        >
          <template #input>
            <div class="input-wrapper">
              <van-icon
                name="friends-o"
                class="input-icon"
              />
              <input
                v-model="newGroupName"
                type="text"
                placeholder="请输入分组名称"
                maxlength="20"
                class="custom-input"
              />
            </div>
          </template>
        </van-field>
      </div>
      <div class="popup-footer">
        <el-button
          round
          type="primary"
          :disabled="!newGroupName.trim()"
          @click="createGroup"
        >
          确认
        </el-button>
      </div>
    </van-popup>

    <!-- 删除确认弹窗 -->
    <!-- <van-dialog
      v-model="showDeleteConfirm"
      title="删除分组"
      show-cancel-button
      @confirm="deleteGroup"
    >
      <div class="delete-confirm-content">
        确定要删除分组"{{ currentGroup?.name }}"吗？
      </div>
    </van-dialog> -->
  </div>
</template>

<script>
import wecomAPI from "@/apis/wecom";
import { Toast } from "vant";

export default {
  name: "GroupManage",

  data() {
    return {
      groupList: [],
      showPopup: false,
      newGroupName: "",
      showDeleteConfirm: false,
      currentGroup: null,
    };
  },

  created() {
    this.fetchGroupList();
  },

  methods: {
    // 获取分组列表
    async fetchGroupList() {
      try {
        // 这里需要添加获取分组列表的接口
        const data = await wecomAPI.getGroupList();

        this.groupList = data;
      } catch (error) {
        Toast("获取分组列表失败");
      }
    },

    // 显示新建分组弹窗
    showAddGroup() {
      this.showPopup = true;
      this.newGroupName = "";
    },

    // 创建分组
    async createGroup() {
      if (!this.newGroupName.trim()) return;

      try {
        await wecomAPI.createGroup({
          name: this.newGroupName.trim(),
        });
        Toast("创建成功");
        this.showPopup = false;
        this.fetchGroupList();
      } catch (error) {
        Toast("创建失败");
      }
    },

    // 显示删除确认弹窗
    confirmDelete(group) {
      this.currentGroup = group;
      this.showDeleteConfirm = true;
    },

    // 删除分组
    async deleteGroup() {
      if (!this.currentGroup) return;

      try {
        await wecomAPI.removeGroup({
          id: this.currentGroup.id,
        });
        Toast("删除成功");
        this.fetchGroupList();
      } catch (error) {
        Toast("删除失败");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.group-manage {
  height: 100vh;
  display: flex;
  flex-direction: column;
  //   background-color: #002d5c;
  .van-cell-group {
    background-color: transparent;
  }

  .group-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    color: #fff;
    font-size: 16px;

    .add-group {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 14px;
      cursor: pointer;

      .van-icon {
        font-size: 16px;
      }
    }
  }

  .group-list {
    flex: 1;
    overflow-y: auto;
    padding: 0 16px;

    .group-item {
      margin-bottom: 8px;
      border-radius: 4px;
      display: flex;
      align-items: center;

      ::v-deep .van-cell__title {
        color: #fff;
      }

      .group-icon {
        margin-right: 8px;
        color: #fff;
      }

      .delete-icon {
        color: #fff;
        font-size: 16px;
        padding: 4px;
      }
    }
  }
}

.add-group-popup {
  .popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    font-size: 16px;
    font-weight: 500;
    border-bottom: 1px solid #eee;

    .van-icon {
      font-size: 20px;
      color: #999;
      cursor: pointer;
    }
  }

  .popup-content {
    padding: 16px;

    .input-wrapper {
      display: flex;
      align-items: center;
      gap: 8px;
      border: 1px solid #eee;
      border-radius: 4px;
      padding: 8px 12px;

      .input-icon {
        color: #999;
      }

      .custom-input {
        flex: 1;
        border: none;
        outline: none;
        font-size: 14px;

        &::placeholder {
          color: #999;
        }
      }
    }
  }

  .popup-footer {
    padding: 16px;
    text-align: center;

    .el-button {
      width: 200px;
      background-color: #002d5c;
      border-color: #002d5c;
    }
  }
}

.delete-confirm-content {
  padding: 20px;
  text-align: center;
  color: #666;
}
.input-wrapper {
  width: 100%;
}

::v-deep .van-popup {
  max-height: 90%;
}
// ::v-deep .van-field__control {
//   width: 100%;
// }
</style>
